import supabase from "./supabase";
import { FunctionsHttpError } from "@supabase/supabase-js";

interface CreateTeacherParams {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  fullName: string;
  school_id: string;
  district_id: string;
}

export async function createTeacher({
  email,
  password,
  firstName,
  lastName,
  fullName,
  school_id,
  district_id,
}: CreateTeacherParams): Promise<{ error: string | null }> {
  const { error } = await supabase.functions.invoke("createTeacher", {
    body: {
      email,
      password,
      firstName,
      lastName,
      fullName,
      school_id,
      district_id,
    },
  });

  if (error && error instanceof FunctionsHttpError) {
    const errorMessage = await error.context.json();
    return { error: errorMessage.error };
  }

  return { error: error?.message || null };
}
